import script from "./NoElementsDisplayCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./NoElementsDisplayCreate.vue?vue&type=script&setup=true&lang=js"

import "./NoElementsDisplayCreate.vue?vue&type=style&index=0&id=428db876&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-428db876"]])

export default __exports__